import type { ColumnsType } from 'antd/es/table';

import NextIcon from '@asset/next.icon.svg?react';
import { ConsumerInterface } from '@interface/consumer/consumer.interface';

import { ConsumerIntegration } from './consumer-integration/consumer-integration';
import { ConsumerUser } from './consumer-user/consumer-user';

export const consumerColumns: ColumnsType<ConsumerInterface> = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 240,
    minWidth: 240,
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    minWidth: 160,
  },
  {
    title: 'Created By',
    dataIndex: 'user',
    key: 'user',
    minWidth: 160,
    render: (user) => <ConsumerUser user={user} />,
  },
  {
    title: 'Active connections',
    key: 'id',
    width: 720,
    render: (consumer) => <ConsumerIntegration key={consumer.id} consumer={consumer} />,
  },
  {
    title: '',
    dataIndex: 'id',
    key: 'actions',
    width: 64,
    render: () => <NextIcon />,
  },
];
